// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__cmQYM","content":"styles_content__rgbQa","row":"styles_row__q2z6K"};